/** Format a language code to a 2-letter uppercase ISO label (e.g. `en-US` -> `EN`). */
export function formatLanguageIso(iso: string = 'en'): string {
	if (iso?.length > 2) {
		return iso.slice(0, 2).toUpperCase();
	}

	return iso?.toUpperCase();
}
